import { APICallV3Post } from 'reactApp/api/APICall';

export class CreateDocAPICall extends APICallV3Post {
    _method = 'document/create';
}
